(() => {
  const config = document.getElementById('mcs-action-tracking');
  if (!config || config.dataset.initialized) return;
  config.dataset.initialized = 'true';

  const preview = config.dataset.preview === 'true';
  const pagePath = config.dataset.pagePath;
  if (!/^\/(?:pages\/[a-z0-9-]+)?\/?$/i.test(pagePath)) return;
  const canonicalPage = new URL(pagePath, config.dataset.siteOrigin).href;
  const startedForms = new WeakSet();
  let panel;
  let output;
  let privacyStatus;
  let sendPreviewEvents = false;

  function tagAvailable() {
    return typeof window.gtag === 'function';
  }

  function privacy() {
    return window.Shopify?.customerPrivacy;
  }

  function permission() {
    try {
      const api = privacy();
      if (!api) return 'Blocked: consent API unavailable';
      const consent = api.currentVisitorConsent();
      if (consent.analytics !== 'yes' || !api.analyticsProcessingAllowed()) {
        return 'Blocked: analytics consent not granted';
      }
      if (consent.sale_of_data === 'no' || !api.saleOfDataAllowed()) {
        return 'Blocked: data sharing opted out';
      }
      return 'Allowed';
    } catch (_) {
      return 'Blocked: consent unavailable';
    }
  }

  function updatePrivacyStatus() {
    if (privacyStatus) privacyStatus.textContent = permission();
  }

  function record(name, details = {}) {
    const status = permission();
    const parameters = {
      send_to: config.dataset.measurementId,
      page_location: canonicalPage,
      page_referrer: '',
      page_path: pagePath,
      ...details,
      ...(preview ? { debug_mode: true, environment: 'development' } : {}),
    };
    const delivery = status !== 'Allowed' ? 'Not sent' : preview && !sendPreviewEvents ? 'Preview only' : tagAvailable() ? 'Sent to Google tag' : 'Blocked: Google tag unavailable';
    if (output) {
      const entry = document.createElement('li');
      entry.textContent = `${name} | ${status} | ${delivery} | ${JSON.stringify(details)}`;
      output.prepend(entry);
      while (output.children.length > 8) output.lastElementChild.remove();
    }
    if ((preview && !sendPreviewEvents) || status !== 'Allowed') return;
    if (!tagAvailable()) return;
    window.gtag('event', name, parameters);
  }

  function venuePath(value) {
    if (!value) return undefined;
    try {
      const path = new URL(value, window.location.origin).pathname;
      return /^\/pages\/[a-z0-9-]+$/i.test(path) ? path : undefined;
    } catch (_) {
      return undefined;
    }
  }

  function classifyClick(element) {
    if (element.matches('.book-a-table-button')) return ['reservation_open'];
    if (element.dataset.menuAction) {
      const venue = venuePath(element.dataset.menuVenue);
      return [element.dataset.menuAction === 'open' ? 'menu_open' : 'menu_select', {
        menu_type: element.dataset.menuType || 'html', ...(venue ? { venue_path: venue } : {})
      }];
    }
    const href = element.getAttribute('href') || '';
    if (/^mailto:/i.test(href)) return ['contact_click', { contact_method: 'email' }];
    if (/^tel:/i.test(href)) return ['contact_click', { contact_method: 'phone' }];

    if (element.matches('.load-pdf-button, .block-button_wine_menu')) {
      const venue = venuePath(element.closest('[data-collapse-id]')?.dataset.collapseId);
      return ['menu_select', { menu_type: element.matches('.block-button_wine_menu') ? 'wine' : 'pdf', ...(venue ? { venue_path: venue } : {}) }];
    }
    if (element.matches('.menus-pdf-collapse-button')) {
      const venue = venuePath(element.dataset.collapseTarget);
      return ['menu_select', { menu_type: 'location', ...(venue ? { venue_path: venue } : {}) }];
    }
    if (element.dataset.targetPage) {
      const venue = venuePath(element.dataset.targetPage);
      return ['menu_open', venue ? { venue_path: venue } : {}];
    }
    if (!href) return null;
    let url;
    try { url = new URL(href, window.location.origin); } catch (_) { return null; }
    if (!['https:', 'http:'].includes(url.protocol)) return null;
    if (url.hostname === 'opentable.com' || url.hostname.endsWith('.opentable.com')) {
      const venues = { '4721': 'bird-road', '16924': 'hialeah', '4722': 'coral-gables' };
      const venue = venues[url.searchParams.get('rid')];
      return ['reservation_click', { booking_provider: 'opentable', ...(venue ? { venue } : {}) }];
    }
    if (/\.pdf$/i.test(url.pathname) && /menu/i.test(url.pathname)) return ['menu_select', { menu_type: 'pdf' }];
    const internal = url.hostname === window.location.hostname || url.hostname === new URL(config.dataset.siteOrigin).hostname;
    if (internal && url.pathname === '/pages/contact') return ['contact_click', { contact_method: 'contact_page' }];
    return null;
  }

  document.addEventListener('click', event => {
    if (!event.isTrusted || !(event.target instanceof Element)) return;
    const element = event.target.closest('a, button');
    if (!element || element.closest('#mcs-tracking-preview')) return;
    const action = classifyClick(element);
    if (action) record(...action);
  }, true);

  document.addEventListener('input', event => {
    if (!event.isTrusted || !(event.target instanceof Element)) return;
    const form = event.target.closest('form.contact-form') || (
      pagePath === '/pages/contact' && event.target.closest('[data-forms-id="forms-root-979743"]')
    );
    if (!form || startedForms.has(form) || permission() !== 'Allowed') return;
    startedForms.add(form);
    record('contact_form_start');
  });

  document.addEventListener('visitorConsentCollected', updatePrivacyStatus);

  if (preview && new URLSearchParams(window.location.search).get('mcs_tracking_preview') === '1') {
    panel = document.createElement('details');
    panel.id = 'mcs-tracking-preview';
    panel.open = true;
    panel.style.cssText = 'position:fixed;bottom:80px;left:12px;z-index:2147483000;max-width:min(540px,calc(100vw - 24px));max-height:45vh;overflow:auto;background:#fff;color:#171813;border:2px solid #963830;padding:12px;font:13px/1.4 system-ui;text-transform:none;box-shadow:0 3px 18px #0003';
    const summary = document.createElement('summary');
    summary.textContent = 'MCS | Development tracking preview';
    panel.append(summary);
    const note = document.createElement('p');
    note.textContent = 'Preview only by default. Debug sending uses the existing GA4 tag and marks events as development. Existing app tracking is unchanged. Consent controls affect only this browser visitor.';
    panel.append(note);
    privacyStatus = document.createElement('p');
    privacyStatus.setAttribute('role', 'status');
    panel.append(privacyStatus);
    for (const [label, consent] of [
      ['Allow analytics', { analytics: true }],
      ['Decline analytics', { analytics: false }],
      ['Opt out of sharing', { sale_of_data: false }],
      ['Allow analytics and sharing', { analytics: true, sale_of_data: true }],
    ]) {
      const button = document.createElement('button');
      button.type = 'button';
      button.textContent = label;
      button.style.cssText = 'margin:4px;padding:6px;border:1px solid #171813;background:#fff;color:#171813;cursor:pointer;font:inherit';
      button.addEventListener('click', () => {
        const api = privacy();
        if (!api) return updatePrivacyStatus();
        privacyStatus.textContent = 'Saving this visitor\'s consent...';
        api.setTrackingConsent(consent, error => {
          if (error) {
            privacyStatus.textContent = 'Unable to save consent in this preview. Events remain blocked.';
            return;
          }
          updatePrivacyStatus();
        });
      });
      panel.append(button);
    }
    const debugLabel = document.createElement('label');
    debugLabel.style.cssText = 'display:block;margin:8px 0';
    const debugToggle = document.createElement('input');
    debugToggle.type = 'checkbox';
    debugToggle.addEventListener('change', () => { sendPreviewEvents = debugToggle.checked; });
    debugLabel.append(debugToggle, ' Send this page\'s checks to GA4 DebugView');
    panel.append(debugLabel);
    output = document.createElement('ol');
    output.setAttribute('aria-label', 'Tracking preview events');
    output.style.cssText = 'margin:8px 0 0;padding-left:20px;overflow-wrap:anywhere';
    panel.append(output);
    document.body.append(panel);
    updatePrivacyStatus();
  }

  if (!privacy() && typeof window.Shopify?.loadFeatures === 'function') {
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], updatePrivacyStatus);
  }
})();
